import { Component, Input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CameraManageConfigHikVision } from '../../../models/Camera';

@Component({
  selector: 'app-hikvision-configs',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ],
  templateUrl: './hikvision-configs.component.html',
  styleUrl: './hikvision-configs.component.scss'
})

export class HikVisionConfigsComponent {
  showPassword = false;

  @Input()
  authConfig: CameraManageConfigHikVision = {};
}
